module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av525-f9107c597c25f6d6ecdb9b7bff361cbc.jpg";